import * as React from "react";
import SelectField, {SelectedValue} from "../../../components/SelectField";
import {SpecDto, SpecDtoSpecCategory} from "../../../services/Client";
import _ from "lodash";
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";
import {translate} from "react-i18next";

interface ISpecConfigurationSpecSelectionProps extends ITranslatedComponent {
    dataSource: Array<any>;
    disabled: boolean;
    value: SpecDto[];
    onChange: (specs: string[]) => void;
}

interface ISpecConfigurationSpecSelectionState {
    value: SpecDto[];
    abgasSpecValue: SpecDto | undefined;
    restSpecsValue: SpecDto[];
}

class SpecConfigurationSpecSelection extends React.Component<ISpecConfigurationSpecSelectionProps, ISpecConfigurationSpecSelectionState> {
    state: ISpecConfigurationSpecSelectionState = {
        value: [],
        abgasSpecValue: undefined,
        restSpecsValue: [],
    };

    componentWillReceiveProps(nextProps: ISpecConfigurationSpecSelectionProps) {
        if (!_.isEqual(nextProps.value, this.state.value)) {
            this.setState({value: nextProps.value,
                abgasSpecValue: _.findLast(nextProps.value, item => item.specCategory === SpecDtoSpecCategory.ABGAS),
                restSpecsValue: _.filter(nextProps.value, item => item.specCategory === SpecDtoSpecCategory.REST)});
        }
    }

    onChangeAbgasSpec(val: SpecDto | undefined): void {

        let newVals = val ? _.concat(val,this.state.restSpecsValue) : this.state.restSpecsValue;

        this.setState({value: newVals, abgasSpecValue: val});
        let res: string[] = [];
        _.forEach(newVals, (v) => {
            res.push(v.specCode);
        });
        this.props.onChange(res);
    }

    onChangeRestSpecs(vals: SpecDto[]): void {

        let newVals = this.state.abgasSpecValue ? _.concat(vals,this.state.abgasSpecValue) : vals;

        this.setState({value: newVals, restSpecsValue: vals});
        let res: string[] = [];
        _.forEach(newVals, (v) => {
            res.push(v.specCode);
        });
        this.props.onChange(res);
    }

    render() {
        let abgasSpecs:SpecDto[] = _.filter(this.props.dataSource, item => item.specCategory === SpecDtoSpecCategory.ABGAS);
        let restSpecs:SpecDto[] = _.filter(this.props.dataSource, item => item.specCategory === SpecDtoSpecCategory.REST);

        return (
           <>
                <SelectField
                    disabled={this.props.disabled}
                    value={this.state.abgasSpecValue}
                    dataSource={abgasSpecs}
                    onChange={(selVal) => this.onChangeAbgasSpec(selVal as SpecDto)}
                    rendererKey={(v: SpecDto) => v.specCode}
                    placeholder={this.props.t("SPECS:ABGAS_SPEC_PLACEHOLDER")}
                />
                <br/>
                <SelectField
                    multi={true}
                    disabled={this.props.disabled}
                    value={this.state.restSpecsValue}
                    dataSource={restSpecs}
                    onChange={(selVals: Array<SelectedValue>) =>  this.onChangeRestSpecs(selVals.map((v) => v.selectedValue) as SpecDto[])}
                    rendererKey={(v: SpecDto) => v.specCode}
                    placeholder={this.props.t("SPECS:REST_SPEC_PLACEHOLDER")}
                />
            </>
        );
    }
}

export default translate("SPECS")(SpecConfigurationSpecSelection);



// WEBPACK FOOTER //
// ./src/views/AdminView/SpecConfigTab/SpecConfigurationSpecSelection.tsx